import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DATETIME_FORMAT_DATE,
  DATETIME_FORMAT_DATETIME,
} from '../utils/helpers/CommonHelper.jsx';
import dayjs from 'dayjs';

export function useFoDateBasicInformation(dateDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!dateDetail) return [];

    return [
      {
        label: t('Názov akcie'),
        value: dateDetail.workshop.event.name,
      },
      {
        label: t('Trvanie akcie'),
        value:
          dayjs(dateDetail.workshop.event.date_from).format(
            DATETIME_FORMAT_DATE,
          ) +
          ' - ' +
          dayjs(dateDetail.workshop.event.date_to).format(DATETIME_FORMAT_DATE),
      },
      {
        label: t('Názov kurzu'),
        value: dateDetail.workshop.name,
      },
      {
        label: t('Názov termínu'),
        value: dateDetail.name,
      },
      {
        label: t('Lektor'),
        value: dateDetail.lecturer.displayname,
      },
      {
        label: t('Termín'),
        value:
          dayjs(dateDetail.date_from).format(DATETIME_FORMAT_DATETIME) +
          ' - ' +
          dayjs(dateDetail.date_to).format(DATETIME_FORMAT_DATETIME),
      },
      {
        label: t('Miestnosť'),
        value: dateDetail.location,
      },
      {
        label: t('Kapacita'),
        value: `${dateDetail.participants_count ?? 0}/${dateDetail.capacity}`,
      },
      {
        label: t('Poznámka'),
        value: dateDetail.note,
        isRaw: true,
      },
    ];
  }, [dateDetail, t]);
}
